module.exports = __webpack_public_path__ + "static/media/TrojanHorse.f6fe6746.jpg";